<template>
    <div>
        <button v-if="this.cart_qty==0" type="button"
                @click="addItem"
                :class="this.css_class_buyLocal">{{this.title_buyLocal}}
        </button>
        <button v-else type="button"
                @click="delItem"
                :class="this.css_class_delLocal">{{this.title_delLocal}}
        </button>
    </div>
</template>

<script>
    export default {
        name: "cart-add-delete-button",
        props: {
            product_id : Number,
            price : Number,
            title_buy : String,
            title_del : String,
            //in_cart_qty : Number,
            variant_id : {
                default: 0,
                type: Number
            },
            css_class_buy : String,
            css_class_del : String
        },
        data() {
            return {
                product_idLocal : this.product_id,
                priceLocal : this.price,
                title_buyLocal : this.title_buy,
                title_delLocal : this.title_del,
                //in_cart_qtyLocal : this.in_cart_qty,
                css_class_buyLocal : this.css_class_buy,
                css_class_delLocal : this.css_class_del,
                variant_idLocal: this.variant_id,
            }
        },
        methods: {
            addItem(event) {
                event.preventDefault();
                this.$store.dispatch(
                    'addProduct',
                    {
                        product_id: this.product_idLocal,
                        qty: 1,
                        variant_id: this.variant_idLocal,
                    })
            },
            delItem(event) {
                event.preventDefault();
                this.$store.dispatch('removeItem', this.cart_item_id)
            }
        },
        computed: {
            cart_qty () {
                const cart_items = this.$store.getters.cartitems;
                let product = cart_items.filter((item) => {
                    return item.product_id===this.product_idLocal;
                });

                if(typeof product[0] !== 'undefined') {
                    return product[0].qty;
                }
                return 0;
            },
            cart_item_id () {
                const cart_items = this.$store.getters.cartitems;
                let product = cart_items.filter((item) => {
                    return item.product_id===this.product_idLocal;
                });
                if(typeof product[0] !== 'undefined') {
                    return product[0].id;
                }
                return 0;
            }
        }
    }
</script>

<style scoped>

</style>